import { ReactNode, useState } from "react";
import { capitalize } from "@sellar-io/common";
import { DataButton } from "@sellar-io/components";
import { Icon } from "../../../components";
import { SlideTransition } from "../../../components/transition/SlideTransition";
import { AllFulfillmentTypesType } from "@sellar-io/api-v2/types";
import { PriceListVolumeDiscountDeleteDialog } from "./PriceListVolumeDiscountDeleteDialog";

export const VolumeDiscountGroupListElement = ({
  assignment,
  priceListId,
  isBasicMode,
  canEdit = true,
  children,
}: {
  assignment: {
    id: number;
    VolumeDiscounts: {
      name: string;
    };
    fulfillmentType: Extract<
      AllFulfillmentTypesType,
      "direct" | "courier" | "haulier" | "collection" | "sellarDistribution"
    > | null;
  };
  priceListId: number;
  isBasicMode: boolean;
  canEdit: boolean;
  children: ReactNode;
}) => {
  const [showDiscounts, setShowDiscounts] = useState(false);
  const [deleteDialogActive, setDeleteDialogActive] = useState(false);

  const fulfillmentType = assignment.fulfillmentType
    ? assignment.fulfillmentType === "sellarDistribution"
      ? "sellar distribution"
      : assignment.fulfillmentType
    : null;

  return (
    <div className="flex cursor-pointer flex-col items-center justify-between gap-3 overflow-hidden rounded-lg border border-solid bg-white p-3 hover:border-zinc-700">
      <div
        className="flex w-full items-center justify-between gap-3"
        onClick={() =>
          setShowDiscounts((prevShowDiscounts) => !prevShowDiscounts)
        }
      >
        <div className="flex flex-col gap-1">
          <span className="font-semibold">
            {assignment.VolumeDiscounts.name}
          </span>
          {!isBasicMode && (
            <span className="text-sm text-zinc-500">
              {fulfillmentType
                ? `Condition: ${capitalize(fulfillmentType)}`
                : "Condition: Default"}
            </span>
          )}
        </div>
        <Icon icon={showDiscounts ? "CHEVRON_UP" : "CHEVRON_DOWN"} />
      </div>
      <SlideTransition
        show={showDiscounts}
        className="flex w-full flex-col gap-2"
        parentClass="w-full"
      >
        {children}
        {canEdit && showDiscounts && (
          <DataButton
            border={true}
            onClick={(e) => {
              e.stopPropagation();
              setDeleteDialogActive(true);
            }}
            className="mb-1 flex items-center gap-1"
          >
            <Icon icon="DELETE" size={0.7} />
            Remove
          </DataButton>
        )}
      </SlideTransition>
      <PriceListVolumeDiscountDeleteDialog
        active={deleteDialogActive}
        onDismiss={() => setDeleteDialogActive(false)}
        priceListVolumeDiscountsId={assignment.id}
        priceListId={priceListId}
        volumeDiscountsSetName={assignment.VolumeDiscounts.name}
      />
    </div>
  );
};
